export const SI_PLATFORM_ID = 5900;
export const SI_PLATFORM_HOST = 'app.smarttinvest.com';

export const DISABLED_PLATFORMS = [
  1000, // smarttbot
];

export default null;
